import styled from 'styled-components'
import { SHADOWS } from 'tokens'

export const BoardWrapper = styled.div`
  width: 100%;
  background: var(--color-bg);
`

export const ColumnsContainer = styled.div`
  display: flex;
  gap: 24px;
`

export const ColumnCard = styled.div`
  min-width: 418px;
  max-height: 851px;
  min-height: 851px;
  background: var(--color-bg);
  border: 1px solid var(--color-border-primary);
  border-radius: 6px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  @media (min-width: 1370px) {
    width: 33%;
  }
`
export const ColumnContent = styled.div`
  overflow-y: auto;
  padding-bottom: 10px;
`
export const ColumnHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  border: 1px solid var(--color-border-primary);
  border-radius: 6px;
  padding: 6px 10px;
  background: var(--color-bg);
`

export const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text-primary);
`

export const Count = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: var(--color-text-primary);
`

export const TimeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Label = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin-top: 8px;
  margin-bottom: 4px;
  color: var(--color-text-primary);
`

export const ColumnFill = styled.div`
  flex: 1;
`
